import type { SVGProps } from 'react';

import { strokeStyle } from '../Illustration.css';
import { useIllustrationShades } from '../Illustration.hooks';

type Props = SVGProps<SVGSVGElement> & {
  strokeWidth: number;
};

export const Platform = ({ strokeWidth, ...delegated }: Props) => {
  const shades = useIllustrationShades();

  return (
    <svg fill="none" height="71" viewBox="0 0 131 71" width="131" xmlns="http://www.w3.org/2000/svg" {...delegated}>
      <path
        className={strokeStyle}
        d="M84.56 16.99H32.77v-6.78a2.63 2.63 0 0 1 2.63-2.63h20.63a2.64 2.64 0 0 1 2.64 2.63 2.63 2.63 0 0 1 2.63-2.63h20.64a2.63 2.63 0 0 1 2.63 2.63z"
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M93.96 10.13v53.54a5.7 5.7 0 0 1-5.71 5.71l-79.37.57a5.7 5.7 0 0 1-4.65-2.42l-.05-.05-.03-.05-2.4-3.53a5.8 5.8 0 0 0 4.39 2.06h79.94c3.15 0 5.14-3.13 5.14-6.29V6.13q0-.47-.08-.92a5.5 5.5 0 0 0-.81-2.14l2.58 3.76a5.7 5.7 0 0 1 1.05 3.29z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M91.22 23.98v35.71c0 3.15-1.98 6.29-5.14 6.29H6.14l-.51-.03a5.8 5.8 0 0 1-3.88-2.03l-.07-.1a5.6 5.6 0 0 1-1.25-3.56V23.98z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M91.22 16.99v6.99H.43v-6.99h32.34v-6.78a2.63 2.63 0 0 1 2.63-2.63h20.63a2.64 2.64 0 0 1 2.64 2.63v6.78z"
        fill={shades.secondary.light}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M91.22 6.13v10.86h-6.66v-6.78a2.63 2.63 0 0 0-2.63-2.63H61.29a2.63 2.63 0 0 0-2.63 2.63 2.64 2.64 0 0 0-2.64-2.63H35.39a2.63 2.63 0 0 0-2.63 2.63v6.78H.43V6.71A5.7 5.7 0 0 1 6.14 1L85.51.43a5.7 5.7 0 0 1 4.61 2.35l.21.3a6 6 0 0 1 .89 3.06z"
        fill={shades.primary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M84.56 10.21v6.78h-25.9v-6.78a2.63 2.63 0 0 1 2.63-2.63h20.64a2.63 2.63 0 0 1 2.63 2.63Z"
        fill={shades.primary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M8.84 11.98a2.2 2.2 0 1 0 0-4.4 2.2 2.2 0 0 0 0 4.4Z"
        fill={shades.primary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M16.07 11.98a2.2 2.2 0 1 0 0-4.4 2.2 2.2 0 0 0 0 4.4Z"
        fill={shades.secondary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M23.31 11.98a2.2 2.2 0 1 0 0-4.4 2.2 2.2 0 0 0 0 4.4Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M45.82 56.44c19.41 0 35.15-.7 35.15-1.55s-15.74-1.55-35.15-1.55-35.15.7-35.15 1.55 15.74 1.55 35.15 1.55Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M34.42 54.15h-.86v-.86c0 .47.38.86.86.86Z" fill={shades.primary.dark} strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M43.16 53.3v.86h-.86c.47 0 .86-.38.86-.86Z" fill={shades.primary.dark} strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M43.08 33.8v2.24h-9.6V33.8c0-.47.38-.86.86-.86h7.89c.47 0 .86.38.86.86z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M43.08 36.03v17.26c0 .47-.38.86-.86.86h-7.89a.86.86 0 0 1-.86-.86V36.03z"
        fill={shades.secondary.dark}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M49.47 54.15h-.86v-.86c0 .47.38.86.86.86Z" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M58.2 53.3v.86h-.86c.47 0 .86-.38.86-.86Z" strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M58.16 33.8v6.79h-9.59V33.8c0-.47.38-.86.86-.86h7.88c.47 0 .86.38.86.86z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M58.16 40.59V53.3c0 .47-.38.86-.86.86h-7.88a.86.86 0 0 1-.86-.86V40.59z"
        fill={shades.secondary.dark}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M64.51 54.15h-.86v-.86c0 .47.38.86.86.86Z" fill={shades.primary.dark} strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M73.25 53.3v.86h-.86c.47 0 .86-.38.86-.86Z" fill={shades.primary.dark} strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M73.25 33.8v9.75h-9.59V33.8c0-.47.38-.86.86-.86h7.88c.47 0 .86.38.86.86z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M73.25 43.55v9.75c0 .47-.38.86-.86.86h-7.88a.86.86 0 0 1-.86-.86v-9.75z"
        fill={shades.secondary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M27.99 33.8v9.75H18.4V33.8c0-.47.38-.86.86-.86h7.88c.47 0 .86.38.86.86z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M27.99 43.55v9.75c0 .47-.38.86-.86.86h-7.88a.86.86 0 0 1-.86-.86v-9.75z"
        fill={shades.secondary.dark}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M4.23 67.54h-.01l-.04-.05z" strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="m124.8 44.81-1.86 1.51-2.44 1.98-4.76-5.05-5.19 4.42-3.02-18.81-.58-3.6 17.98 11.44-2.31 1.76-2.34 1.77 1.46 1.48z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m124.93 36.7-.48 2.94-2.71 2.07-1.46-1.48 2.34-1.77z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m124.8 44.81-.47 2.94-4.29 3.48-4.77-5.04-5.2 4.41-3.59-22.41.47-2.93.58 3.6 3.02 18.81 5.19-4.42 4.76 5.05 2.44-1.98z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M127.32 6.93v5.69" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M130.38 9.78h-6.11" strokeWidth={strokeWidth} />
    </svg>
  );
};
